import React from "react";
import Image from "next/image";
import { DeleteIcon, Download, Edit, EllipsisVertical, HeartFilled, HeartOutline, ShareIcon, TrophyIcon } from "components/atoms/Icon";
import PopoverWithChildren from "components/atoms/Popover";
import { Span } from "utils/styling/typography.styled";
import * as Styled from "./ControlsContainer.styled";
interface ControlsContainerProps {
  imageInfo: any;
  toggles: {
    [key: string]: boolean;
  };
  handleToggle: (id: string) => void;
  handleShareClick: (e: React.MouseEvent, imageId?: string) => void;
  handleCompetitionsClick: (imageId?: string) => void;
  handleEditClick: (imageId?: string) => void;
  prepareForDelete: (id: string) => void;
  handleVote: (id: string) => void;
  showEdit: boolean;
  isUserImage: (username: string) => boolean;
}
const ControlsContainer: React.FC<ControlsContainerProps> = ({
  imageInfo,
  toggles,
  handleToggle,
  handleShareClick,
  handleCompetitionsClick,
  handleEditClick,
  prepareForDelete,
  handleVote,
  showEdit,
  isUserImage
}) => {
  return <Styled.ControlsContainer data-sentry-element="unknown" data-sentry-component="ControlsContainer" data-sentry-source-file="index.tsx">
            <Styled.Icon id="shareIcon" aria-label="Share this image" onClick={e => handleShareClick(e, imageInfo.id)} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.IconWrapper data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Image height={24} width={24} priority src={ShareIcon} alt="Share" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
                </Styled.IconWrapper>
            </Styled.Icon>
            <PopoverWithChildren buttonNode={<Styled.Icon>
                        <Styled.IconWrapper>
                            <Image height={24} width={24} priority src={EllipsisVertical} alt="Edit" />
                        </Styled.IconWrapper>
                    </Styled.Icon>} data-sentry-element="PopoverWithChildren" data-sentry-source-file="index.tsx">
                <Styled.PopoverItem data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <a href={imageInfo.image} download target="_blank" rel="noreferrer">
                        <Styled.IconWrapper data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                            <Image height={24} width={24} priority src={Download} alt="Download" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
                        </Styled.IconWrapper>
                    </a>
                    <span>Download</span>
                </Styled.PopoverItem>
                {isUserImage(imageInfo.imageMetadata.username) && <>
                        <Styled.PopoverItem onClick={() => handleCompetitionsClick(imageInfo.id)}>
                            <Styled.IconWrapper>
                                <Image height={24} width={24} priority src={TrophyIcon} alt="Competition" />
                            </Styled.IconWrapper>

                            <span>Enter Competition</span>
                        </Styled.PopoverItem>
                    </>}
                {showEdit && isUserImage(imageInfo.imageMetadata.username) && <Styled.PopoverItem onClick={() => handleEditClick(imageInfo.id)}>
                        <Styled.IconWrapper>
                            <Image height={24} width={24} priority src={Edit} alt="Edit" />
                        </Styled.IconWrapper>
                        <span>Edit</span>
                    </Styled.PopoverItem>}
                {isUserImage(imageInfo.imageMetadata.username) && <Styled.PopoverItem onClick={() => prepareForDelete(imageInfo.id)}>
                        <Styled.IconWrapper>
                            <Image height={24} width={24} priority src={DeleteIcon} alt="Delete" />
                        </Styled.IconWrapper>
                        <span>Delete</span>
                    </Styled.PopoverItem>}
            </PopoverWithChildren>
            {isUserImage(imageInfo.imageMetadata.username) && <Styled.PopoverItem>
                    <Styled.SmallToggleSwitch>
                        <input id={`visibilityToggle-${imageInfo.id}`} type="checkbox" checked={toggles[imageInfo.id]} onChange={() => handleToggle(imageInfo.id)} />
                        <span className="slider round"></span>
                    </Styled.SmallToggleSwitch>
                    <span>{toggles[imageInfo.id] ? "Public" : "Private"}</span>
                </Styled.PopoverItem>}
            <Styled.ReactContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.Icon key={imageInfo.id} onClick={() => handleVote(imageInfo.id)} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.HeartCheckbox data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
                    <Styled.IconWrapper data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        {imageInfo.isVotedByUser ? <Image height={24} width={24} priority src={HeartFilled} alt="Heart" /> : <Image height={24} width={24} priority src={HeartOutline} alt="Heart" />}
                    </Styled.IconWrapper>
                </Styled.Icon>
                <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">{imageInfo.voteCount}</Span>
            </Styled.ReactContainer>
        </Styled.ControlsContainer>;
};
export default ControlsContainer;